module.exports = __webpack_public_path__ + "img/TreantProtector.313a8fbb.png";